import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPropertiesInputDto, PropertyCreateDto, PropertyDto, PropertyExcelDownloadDto, PropertyUpdateDto } from '../dtos/property/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PropertyService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: PropertyCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyDto>({
      method: 'POST',
      url: '/api/planning/properties',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/properties/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/properties',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyDto>({
      method: 'GET',
      url: `/api/planning/properties/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/properties/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPropertiesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PropertyDto>>({
      method: 'GET',
      url: '/api/planning/properties',
      params: { name: input.name, propertyCode: input.propertyCode, zoneId: input.zoneId, regionId: input.regionId, zoneName: input.zoneName, internalOrderId: input.internalOrderId, vendorId: input.vendorId, fomentContractId: input.fomentContractId, commercialAgentId: input.commercialAgentId, millId: input.millId, remsoft: input.remsoft, strategicCommercialZoneId: input.strategicCommercialZoneId, strategicCommercialZoneName: input.strategicCommercialZoneName, isDisabled: input.isDisabled, transportAccessTypeId: input.transportAccessTypeId, seasonTypeId: input.seasonTypeId, locationId: input.locationId, locationName: input.locationName, locationIsActive: input.locationIsActive, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PropertyExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/properties/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, propertyCode: input.propertyCode, zoneId: input.zoneId, regionId: input.regionId, zoneName: input.zoneName, internalOrderId: input.internalOrderId, vendorId: input.vendorId, fomentContractId: input.fomentContractId, commercialAgentId: input.commercialAgentId, millId: input.millId, remsoft: input.remsoft, strategicCommercialZoneId: input.strategicCommercialZoneId, strategicCommercialZoneName: input.strategicCommercialZoneName, isDisabled: input.isDisabled, transportAccessTypeId: input.transportAccessTypeId, seasonTypeId: input.seasonTypeId, locationId: input.locationId, locationName: input.locationName, locationIsActive: input.locationIsActive, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyDto[]>({
      method: 'GET',
      url: '/api/planning/properties/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PropertyUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyDto>({
      method: 'PUT',
      url: `/api/planning/properties/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}